import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";

const splitParagraphs = (value) => `${value || ""}`.split("\n").map((item) => item.trim()).filter(Boolean);

export const FormationProgramDialog = ({ formation, onClose }) => {
  const isOpen = Boolean(formation);

  return (
    <Dialog onOpenChange={(open) => { if (!open) onClose(); }} open={isOpen}>
      <DialogContent className="max-w-4xl overflow-hidden rounded-[2rem] border-[#d9e7d5] bg-white p-0 shadow-[0_34px_100px_-54px_rgba(15,118,110,0.35)]" data-testid="formation-program-dialog-content">
        {formation ? (
          <>
            <DialogHeader className="border-b border-[#e8f2ee] bg-[linear-gradient(180deg,_rgba(248,252,243,0.95)_0%,_rgba(255,255,255,0.98)_100%)] px-6 py-6 text-left sm:px-8 sm:py-8">
              <DialogTitle className="bim-display text-2xl font-semibold tracking-tight text-slate-950" data-testid="formation-program-dialog-title">
                {formation.title}
              </DialogTitle>
              <DialogDescription className="mt-2 max-w-2xl text-sm leading-7 text-slate-600" data-testid="formation-program-dialog-description">
                Consultez le détail de la formation, ses objectifs et le programme structuré. Tous les tarifs affichés sont en HT.
              </DialogDescription>
            </DialogHeader>

            <div className="max-h-[72vh] overflow-y-auto px-6 py-6 sm:px-8 sm:py-8" data-testid="formation-program-dialog-body">
              <section className="rounded-[1.75rem] border border-[#d8ece4] bg-[linear-gradient(180deg,_rgba(248,252,243,0.8)_0%,_rgba(255,255,255,0.98)_100%)] p-6 shadow-[0_22px_60px_-46px_rgba(15,118,110,0.22)]" data-testid="formation-program-description-block">
                <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0f766e]">Description & objectifs</div>
                <div className="mt-4 space-y-4 text-sm leading-7 text-slate-600 sm:text-base">
                  {splitParagraphs(formation.description).map((paragraph, index) => (
                    <p data-testid={`formation-program-description-paragraph-${index + 1}`} key={`description-${index + 1}`}>{paragraph}</p>
                  ))}
                  {splitParagraphs(formation.objectives).map((paragraph, index) => (
                    <p data-testid={`formation-program-objectives-paragraph-${index + 1}`} key={`objectives-${index + 1}`}>
                      {paragraph}
                    </p>
                  ))}
                </div>
              </section>

              <section className="mt-6 rounded-[1.75rem] border border-[#d9e7d5] bg-white p-6 shadow-[0_22px_60px_-46px_rgba(15,118,110,0.18)]" data-testid="formation-program-sections-block">
                <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0f766e]">Programme</div>
                <div className="mt-5 space-y-5">
                  {formation.programSections.map((section, index) => (
                    <div className="rounded-[1.4rem] border border-slate-200 bg-slate-50/80 p-5" data-testid={`formation-program-section-${index + 1}`} key={section.id}>
                      <h3 className="text-base font-semibold text-slate-950" data-testid={`formation-program-section-title-${index + 1}`}>
                        {section.title}
                      </h3>
                      <ul className="mt-3 space-y-2 text-sm leading-7 text-slate-600" data-testid={`formation-program-section-items-${index + 1}`}>
                        {section.items.map((item, itemIndex) => (
                          <li className="flex gap-3" data-testid={`formation-program-section-item-${index + 1}-${itemIndex + 1}`} key={`${section.id}-${itemIndex + 1}`}>
                            <span className="mt-2 h-2 w-2 rounded-full bg-[#0f766e]" />
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </section>
            </div>
          </>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};